import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';

import { SelectionStep } from '@warrenbrasil/nebraska-web';
import { FeedbackModal } from './components/FeedbackModal';

import { RLPSteps } from '../../types';
import {
  RLPPageData,
  RLPStatus,
  updateRLPStatus,
  UpdateRLPStatusValues
} from '@/modules/trade/services/rlp';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';

interface Props {
  pageData: RLPPageData;
}
interface Emits {
  (e: 'change-step', step: RLPSteps): void;
  (e: 'refresh'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CancellationForm',
  props: {
    pageData: null
  },
  emits: ["change-step", "refresh"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'change-step', step: RLPSteps): void;
  (e: 'refresh'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  pageData: RLPPageData;
};





const selectedOption = ref('');
const isButtonDisabled = ref(true);
const isFeedbackModalOpen = ref(false);
const isLoading = ref(false);

const options = computed(() => {
  return props.pageData.form.cancellation?.options.map(option => ({
    title: option.label,
    value: option.label
  }));
});

const head = computed(() => {
  return props.pageData.form.cancellation?.head;
});

const title = computed(() => {
  return props.pageData.form.cancellation?.title;
});

const subtitle = computed(() => {
  return props.pageData.form.cancellation?.subtitle;
});

const handleOptionChange = (value: string) => {
  if (value === options.value?.[2].value) {
    isButtonDisabled.value = true;
    return openFeedbackModal();
  }
  selectedOption.value = value;
  isButtonDisabled.value = false;
};

const openFeedbackModal = () => {
  isFeedbackModalOpen.value = true;
};

const closeFeedbackModal = () => {
  isFeedbackModalOpen.value = false;
};

const handleGoBack = () => {
  emit('change-step', RLPSteps.Information);
};

const handleSubmit = async () => {
  closeFeedbackModal();

  try {
    if (isLoading.value) return;
    isLoading.value = true;

    const data = await updateRLPStatus(UpdateRLPStatusValues.disable);

    notify({
      group: 'wrn-notifications',
      text: data.message,
      type:
        data.status === RLPStatus.Inactive
          ? NotificationTypes.success
          : NotificationTypes.info,
      duration: 6000
    });

    emit('refresh');
    handleGoBack();
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Não foi possível desativar o Warren RLP. Aguarde um momento e tente novamente.',
      type: NotificationTypes.error
    });
  } finally {
    isLoading.value = false;
  }
};

return { __sfc: true,props, emit, selectedOption, isButtonDisabled, isFeedbackModalOpen, isLoading, options, head, title, subtitle, handleOptionChange, openFeedbackModal, closeFeedbackModal, handleGoBack, handleSubmit, SelectionStep, FeedbackModal }
}

})